/*
  One cart-add for the three Portico direct-to-checkout surfaces: the tier
  cards, the ritual-set cards, and the quiz result cards.

  Why the gift travels in the SAME /cart/add.js call as the paid line: the
  kg-gift-autoadd runner does see the mutation (it wraps window.fetch), but it
  then debounces 150ms and makes two more round trips of its own, so it loses
  the race to window.location every time and the gift never reaches checkout.
  Sending both lines together also leaves the runner nothing to do — it finds
  the line already present and takes no action.

  Gift lines come from snippets/portico-gift-lines.liquid, the same source the
  card's own gift disclosure reads, so a card cannot show one gift and add
  another. Properties match what the runner would have written, so a gift added
  here and a gift added by the runner are the same line to every consumer
  (discount Function, Smart Cart, the What-is-included meta state).
*/
window.kgPorticoBuildItems = function (paidItem, giftLinesJson) {
  var items = [paidItem];
  var giftLines;

  try {
    giftLines = JSON.parse(giftLinesJson || '[]');
  } catch (error) {
    console.error('[kg-portico] gift lines are not valid JSON', error);
    return items;
  }

  giftLines.forEach(function (gift) {
    // A gift that belongs to the Order must not ride along on a one-off add.
    if (gift.requires_selling_plan && !paidItem.selling_plan) return;
    items.push({
      id: Number(gift.id),
      quantity: 1,
      properties: { _kg_pgift: gift.handle, _r_gwp_hide_qty: 'true' }
    });
  });

  return items;
};
